import React, { useEffect, useState } from "react";

const base = process.env.PUBLIC_URL || "";

export const Spud: React.FC = () => {
   const [visible, setVisible] = useState(true);
   const [x, setX] = useState(0);

   useEffect(() => {
      setX(Math.random() * (window.innerWidth - 200));
      const timer = setTimeout(() => setVisible(false), 7220);
      return () => clearTimeout(timer);
   }, []);

   if (!visible) return null;

   return (
      <img
         src={`${base}/images/rmt/cat.gif?${Date.now()}`} // forces GIF restart
         className="floating-cat"
         style={{ left: `${x}px` }}
         alt="Spud the cat"
      />
   );
};